import AdminKnowledgeHubSettings from './AdminKnowledgeHubSettings';
export default AdminKnowledgeHubSettings;
